





















































































































import Vue from 'vue'
import { getMobileTheme } from '@/helper'
import { AssessmentStatusService, QuizService } from '@/services'
import BaseIcon from '@/components/svgicons/BaseIcon.vue'
import UISpinner from '@/components/common/UISpinner.vue'
import CategoryTreeNode, {
  CategoryTreeNodeType
} from '@/models/CategoryTreeNode'
import { findNextPostId, findPreviousPostId } from '@/helper/index'

export default Vue.extend({
  components: {
    BaseIcon,
    UISpinner
  },
  props: {
    product: {},
    activePost: {},
    category: {},
    categoryTree: {},
    playlist: {},
    fetchingPostCompletionStatus: Boolean,
    disablePostCompletionButton: Boolean,
    isAdmin: Boolean,
    markCompletedBtnCss: String,
    postCompletionButtonText: String
  },
  async mounted() {
    this.updateTheme()
    await Promise.all([this.fetchQuiz(), this.getLastSubmission()])
    this.updateBackData({
      name: 'category-overview',
      params: {
        id: this.productId,
        category_id: this.categoryId
      }
    })
  },
  data() {
    return {
      theme: {},
      quiz: {},
      lastSubmission: {},
      fetchingData: false
    }
  },
  computed: {
    productId() {
      return this.product.id
    },
    categoryId() {
      return this.category.id
    },
    postId() {
      return this.activePost.id
    },
    quizId() {
      return this.lastSubmission && this.lastSubmission.quizId
    },
    availableCategoryTree(): object {
      return this.categoryTree.filter((node: any) => node.node.available)
    },
    availablePlayList(): Array<CategoryTreeNode> {
      return this.playlist.filter(
        (node: any) =>
          node.type === CategoryTreeNodeType.Post ||
          (node.type === CategoryTreeNodeType.Category && node.node.available)
      )
    },
    previousPostData(): object {
      return findPreviousPostId(
        this.availableCategoryTree,
        this.postId,
        this.category,
        this.availablePlayList
      )
    },
    nextPostData(): object {
      return findNextPostId(
        this.availableCategoryTree,
        this.postId,
        this.category,
        this.availablePlayList
      )
    }
  },
  methods: {
    async fetchQuiz() {
      this.fetchingData = true
      try {
        this.quiz = await QuizService.findById(this.activePost.id)
      } catch (error) {
        console.error('Error while fetching quiz!', error)
      } finally {
        this.fetchingData = false
      }
    },
    async getLastSubmission() {
      this.fetchingData = true
      try {
        const lastSubmission = await AssessmentStatusService.getLastSubmissionByPostId(
          this.postId
        ).then(({ data }) => (data ? data : {}))
        this.lastSubmission = lastSubmission.lastSubmission
      } catch (error) {
        console.error('Error while fetching last submission!', error)
      } finally {
        this.fetchingData = false
      }
    },
    async togglePostCompletion() {
      if (this.lastSubmission.status !== 'passed') return
      await this.$emit('togglePostCompletion')
    },
    startQuiz() {
      this.$router.push({
        name: 'mobile-quiz-questions',
        params: {
          id: this.productId,
          post_id: this.postId,
          category_id: this.categoryId,
          quiz_id: this.quizId
        }
      })
    },
    gotoPreviousPost() {
      this.$router.push({
        name: 'post-overview',
        params: {
          id: this.productId,
          category_id: this.previousPostData.categoryId || this.categoryId,
          post_id: this.previousPostData.postId
        },
        query: {
          template_id: this.templateId
        }
      })
    },
    goToNextPost() {
      this.$router.push({
        name: 'post-overview',
        params: {
          id: this.productId,
          category_id: this.nextPostData.categoryId,
          post_id: this.nextPostData.postId
        },
        query: {
          template_id: ''
        }
      })
    },
    updateTheme() {
      this.theme = getMobileTheme()
    },
    updateBackData(params) {
      this.$emit('updateBackData', params)
    }
  }
})
